import { InventoryProductFixQuantityComponent } from 'components/molecules/InventoryProductFixQuantity'
import { useInventoryProductFix } from './InventoryProductFix.hooks'
import { AtlasBodyMain, AtlasBodySubtitle, AtlasListAtom, Filler, Icons, PageContentAtom, PrimaryButtonAtom, StackAtom, TextBoxMolecule, ToolbarMolecule } from '@justomx/atlas-components'
import { TextAreaMolecule } from 'components/molecules/TextArea.molecule'
import { ProductCard } from 'components/molecules/v2/ProductCard.molecule'

function formatStock (stock: number, isWeighable: boolean): string {
  if (isWeighable) {
    return `${stock} g`
  } else {
    return `${stock} ${stock > 1 ? 'piezas' : 'pieza'}`
  }
}

export const InventoryProductFixPage = () => {
  const {
    value,
    canConfirm,
    origin,
    actions,
    loading,
    description
  } = useInventoryProductFix()
  const onChangeQuantity = (value: string) => { actions.setQuantity(value) }
  const onChangeDescription = (value: string) => { actions.setDescription(value) }
  return <>
        <ToolbarMolecule title='Reajustar productos'
                         actionIcon={Icons.ArrowBack}
                         onAction={actions.goBack}
                         data-test='product-fix-toolbar'/>
        <PageContentAtom>
          <StackAtom gap={32}>
            <ProductCard product={value} showTitle={true} title='Producto seleccionado'/>
            <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
              <AtlasBodySubtitle>Instrucciones</AtlasBodySubtitle>
              <AtlasListAtom style={{listStyleType: 'decimal'}}>
                <li><AtlasBodyMain display="contents">Cuenta el inventario del producto en la ubicación.</AtlasBodyMain></li>
                <li><AtlasBodyMain display="contents">Escribe la cantidad y motivo. </AtlasBodyMain></li>
              </AtlasListAtom>
            </div>
            <TextBoxMolecule
              type='number'
              label='Cantidad'
              // value={value.stock}
              onChange={onChangeQuantity}
            />
            <TextAreaMolecule
              label='Motivo'
              value={description}
              onChange={onChangeDescription}
              supportingText='Escribe mínimo 10 caracteres y máximo 140.'
              hasErrors={description.length > 0 && canConfirm.hasErrors}
            /> 
          </StackAtom>
          <Filler/>
          <PrimaryButtonAtom
            disabled={loading || canConfirm.disabled }
            onClick={actions.confirm}>Confirmar
          </PrimaryButtonAtom>
        </PageContentAtom>
    </>
}
